export const AllOutrightsTabId = "-1";
//# sourceMappingURL=index.js.map